import axios from 'axios';
import imageCompression from 'browser-image-compression';

import { getApiUrl } from '@/helpers/api';

export const usePostDocument = () => {
  const postDocument = async (payload) => {
    try {
      const url = `${getApiUrl()}/document`;
      const response = await axios.post(url, payload);
      return response.data;
    } catch (err) {
      throw Error(err.response.data.message);
    }
  };

  return postDocument;
};

export const useDeleteDocument = () => {
  const deleteDocument = async (id) => {
    try {
      const url = `${getApiUrl()}/document/${id}`;
      const response = await axios.delete(url);
      return response.data;
    } catch (err) {
      throw Error(err.response.data.message);
    }
  };

  return deleteDocument;
};

export const useDocumentPreview = () => {
  const getDocumentPreview = async (document) => {
    try {
      // Get download signature
      const url = `${getApiUrl()}/document/${document.id}/download-signature`;
      const signatureResponse = await axios.get(url);
      const signedUrl = signatureResponse.data.signedUrl;

      // Download the actual file
      const fileResponse = await axios.get(signedUrl, {
        responseType: 'blob',
        withCredentials: false
      });

      const contentType = fileResponse.headers['content-type'];

      if (contentType.startsWith('image/')) {
        // For images, resize using browser-image-compression
        const options = {
          maxSizeMB: 1.5,
          maxWidthOrHeight: 380,
          useWebWorker: true
        };

        const compressedFile = await imageCompression(
          fileResponse.data,
          options
        );
        return window.URL.createObjectURL(compressedFile);
      } else {
        // For non-image files, return the signed URL directly
        return signedUrl;
      }
    } catch (err) {
      throw Error(err.response.data.message);
    }
  };

  return getDocumentPreview;
};
